module.exports = __webpack_public_path__ + "media/honey-icons/icon-fan-off-bcfb5d26.svg";